export default __webpack_public_path__ + "static/media/chevron-left.87250760.svg";